export default __webpack_public_path__ + "static/media/rating_9.22b88844.svg";